/**
 * @ignore
 * Created by shanie on 12/8/16.
 */

import React from 'react';
import PropTypes from 'prop-types';

// Components
import CheckMarkIcon from 'dibs-vg/dist/react/checkmark';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles/SelectableContainer.scss';

const SelectableContainer = props => {
    const { isListView, isHovering, isTablet, reordering, selected, selectItem, selecting } = props;

    let dataTn = 'favorites-select-icon-marker';
    const showRevealMarker = !selecting && !reordering && !isTablet;

    if (showRevealMarker) {
        dataTn = 'favorites-select-icon-reveal-marker';
    }

    const markerClasses = classnames({
        [styles.marker]: (selecting && !reordering) || isTablet,
        [styles.revealMarker]: showRevealMarker,
        [styles.stickMarker]: selected && !reordering,
        [styles.noMarker]: reordering,
        [styles.isHovering]: isHovering,
        [styles.listView]: isListView,
    });

    return (
        <div className={markerClasses} data-tn={dataTn} onClick={selectItem}>
            <CheckMarkIcon className={styles.checkIcon} />
        </div>
    );
};

SelectableContainer.propTypes = {
    isListView: false,
};

SelectableContainer.propTypes = {
    isListView: PropTypes.bool,
    isHovering: PropTypes.bool,
    isTablet: PropTypes.bool,
    reordering: PropTypes.bool,
    selected: PropTypes.object,
    selectItem: PropTypes.func,
    selecting: PropTypes.bool,
};

export default SelectableContainer;
